module.exports = __webpack_public_path__ + "img/IconLayers.f1107e6e.svg";